import { apiFetch } from '../configuration/apiFetch';
import { createMsgToast } from '../store/globalSlice';
import { store } from '../store/store';
import { API_URLS } from '../configuration/api.constants';


export const authSSO = (params) => {
  const fetchSettings = {
    method: "GET",
    url: API_URLS.AUTH,
    data: params,
    headerParams: false,
    api: process.env.REACT_APP_AUTH_API
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      if(response.response) throw response
      resolve(response)
    }).catch((response)=>{
      store.dispatch(createMsgToast({body: response.message, title:"Error", variant:"negative"}))
    })
  })
  return dataFetch
}

export const checkUser = (params) => {
  const fetchSettings = {
    method: "PUT",
    url: API_URLS.CHECK_USER,
    data: params,
    body: true
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      if(response.response) throw response
      resolve(response)
    }).catch((response)=>{
      store.dispatch(createMsgToast({body: response.message, title:"Error", variant:"negative"}))
    })
  })
  return dataFetch
}

export const getMaintenance = () => {
  const fetchSettings = {
    method: "GET",
    url: API_URLS.MAINTENANCE,
    originApp: true,
    api: process.env.REACT_APP_AUTH_API
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      resolve(response.maintenance)
    })
  })
  return dataFetch
}